import React from 'react';
import PropTypes from 'prop-types';

export default class AppErrorBoundary extends React.Component {
	static propTypes = {
		children: PropTypes.oneOfType([
			PropTypes.node,
			PropTypes.arrayOf(PropTypes.node),
		]).isRequired,
		setErrors: PropTypes.func.isRequired,
		renderError: PropTypes.func.isRequired,
		hasError: PropTypes.bool.isRequired,
		pathname: PropTypes.string,
		// the idea of the current pathname and set set errorPathname
		errorPathname: PropTypes.string, // errorPathname will contain the pathname where the error was inital trigger see the ErrorBoundaryContext for more info
		client: PropTypes.object,
	};

	componentDidCatch(error, errorInfo) {
		this.updateErrors({ hasError: true, error, errorInfo });
	}

	updateErrors = ({ hasError, error, errorInfo }) => {
		const { pathname } = this.props;
		this.props.setErrors({
			error,
			hasError,
			errorInfo,
			errorPathname: pathname,
		});
	};

	render() {
		const {
			client,
			pathname,
			hasError,
			children,
			setErrors,
			renderError,
			errorPathname,
		} = this.props;

		if (hasError) {
			if (pathname !== errorPathname) {
				client.resetStore();
				setErrors({});
			}
			return renderError();
		}
		return children;
	}
}
